module.exports = __webpack_public_path__ + "img/convenio_midas.ebbcf577.jpg";